import { getClientName } from 'components/roster-portal/activity-planning/utils';
import {
  StyledNameSectionBox,
  StyledNameSectionTypography
} from './NameSection.styles';
import { NameSectionProps } from './NameSection.types';

const NameSection = ({
  planningEntityType,
  activity,
  client,
  isAbsent,
  titleLineClamp,
  isSideDrawer = false
}: NameSectionProps) => {
  function getTitle() {
    if (planningEntityType === 'CLIENT') {
      return activity?.name ?? '';
    }
    return !client && activity ? activity.name : getClientName(client);
  }

  const title = getTitle();
  return (
    <StyledNameSectionBox isSideDrawer={isSideDrawer}>
      <StyledNameSectionTypography
        variant="body1"
        component="h4"
        lineClamp={titleLineClamp}
        isAbsent={isAbsent}
      >
        {title}
      </StyledNameSectionTypography>
    </StyledNameSectionBox>
  );
};

export default NameSection;
